<template>
    <div class="header-page">
        <div class="header-cont">
            <div class="header-top">
                <van-search v-model="search" clearable @clear="clear" @search="searchlist" placeholder="请输入用户名或手机号码" />
            </div>
        </div>
        <!-- 筛选组件 -->
        <div class="screen">
            <van-tabs v-model="current" @click="currentChange">
                <van-tab :title="item.label" :name="item.value" v-for="(item, index) in statusOptions " :key="index">
                </van-tab>
            </van-tabs>
        </div>
        <div class="describe" v-if="status === 1">
            初审已通过，根据明细跟进用户完成激活或首刷后，即可获得佣金，超出各银行激活或首刷最长核卡期后，进入未通过。
        </div>
        <div class="describe" v-if="status === 0">
            申卡用户进入申卡页面浏览和申卡记录，不能全部视为申卡成功订单。根据银行结算周期，银行数据导入后，申卡通过即已完成。
        </div>
        <div class="describe" v-if="status === 8">
            申卡订单以后台进件时间为准，如达标时间超出各银行结算周期规定的时间即为达标超时。
        </div>
        <!-- 列表数据 -->
        <div class="list-cont" v-if="cardlistts">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onRefresh">
                <div v-for="(item, index) in cardlist" class="list-tmp" :key="index">
                    <div class="uni-flex list-me" style="display: flex;">
                        <div class="list-le">
                            <div class="list-pm">
                                <span class="list-span">{{ item.applyName }}</span>
                                <span class="list-pan">{{ item.applyPhone }}</span>
                            </div>
                            <div class="list-yin">
                                <span v-if="item.lable" class="list-tag"
                                    :style="{ backgroundColor: item.lableColorCode }">{{ item.lable
                                    }}</span>
                                <span class="lisy-lm">{{ item.applyProductName }}</span>
                                <span class="lisy-qm">{{ item.label }}</span>
                            </div>
                        </div>
                        <div class="list-r">
                            <div class="list-r-schedule" @click="openUrl(item.bankUrl)">{{
                                item.bankUrl ? "申卡进度 >" : ""
                            }}</div>
                            <div :class="item.statclass" style="line-height: 90rpx; text-align: end">{{ item.statuspay }}
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="list-data">
                        <div class="uni-flex" style="justify-content: space-between;display: flex;">
                            <div class="uni-flex" style="display: flex;">
                                <div v-if="item.s1AmoutType == 1">初审奖励佣金：</div>
                                <div v-if="item.s1AmoutType == 2">激活奖励佣金：</div>
                                <div v-if="item.s1AmoutType == 3">首刷奖励佣金：</div>
                                <div v-if="item.s1AmoutType == 4">终审奖励佣金：</div>
                                <div>{{ item.s1Amount }}</div>
                            </div>
                            <div>{{
                                item.s1GetAmountFlag == "0" ? "未下发" : "已下发"
                            }}</div>
                        </div>
                        <div class="uni-flex" style="justify-content: space-between;display: flex">
                            <div class="uni-flex" style="display: flex;">
                                <div v-if="item.s2AmoutType == 1">初审奖励佣金：</div>
                                <div v-if="item.s2AmoutType == 2">激活奖励佣金：</div>
                                <div v-if="item.s2AmoutType == 3">首刷奖励佣金：</div>
                                <div v-if="item.s2AmoutType == 4">终审奖励佣金：</div>
                                <div v-if="item.s2AmoutType != null">{{ item.s2Amount }}</div>
                            </div>
                            <div v-if="item.s2AmoutType != null">{{
                                item.s2GetAmountFlag == "0" ? "未下发" : "已下发"
                            }}</div>
                        </div>
                        <div class="uni-flex" style="display: flex;">
                            <div>申请时间：</div>
                            <div>{{ item.createTime }}</div>
                        </div>
                        <div class="uni-flex" style="color: #E02020;display: flex;">
                            <div>最新更新时间：</div>
                            <div>{{ item.lastUpdateTime }}</div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class="pagesli" v-else>
            <img class="pagesli" src="../../assets/activityUrl/nodata.jpg" alt="">
        </div>
    </div>
</template>
<script>
import {
    Toast
} from "vant";
import { getOrderStatus, getOrderList } from '@/api/index';
export default {
    data() {
        return {
            loading: false,
            finished: true,
            current: '',
            search: "", //搜索内容
            refresherEnabled: true,
            triggered: false,
            total: 0, //总条数
            pageNum: 1,
            pageSize: 10,
            cardlist: [],
            cardlistts: true,
            status: "",
            statclass: "",
            statusOptions: [],
            currentIndex: 0,
        }
    },
    mounted() {
        this.getdata()
        this.getOrderStatus()
    },
    methods: {
        scroll() {

        },
        currentChange(item, index) {
            if (this.currentIndex == index) {
                return
            }
            this.currentIndex = index
            this.status = item

            this.getdata()
        },
        // 获取订单状态下拉
        getOrderStatus() {
            getOrderStatus(this.$store.getters.getToken).then(res => {
                this.statusOptions = res.data
                this.statusOptions.unshift({
                    label: '全部',
                    value: ''
                })
            })
        },
        // 数据列表
        getdata() {
            let data = {
                applyLike: this.search,
                status: this.status,
            }
            getOrderList(this.pageNum, this.pageSize, data,this.$store.getters.getToken).then((res) => {
                if (res.code == 200) {
                    let rows = res.data.rows
                    if (rows.length > 0) {
                        this.cardlistts = true;
                    } else {
                        this.cardlistts = false;
                    }
                    if (this.pageNum == 1) {
                        this.cardlist = rows;
                    } else {
                        this.cardlist = [...this.cardlist, ...rows];
                    }
                    this.total = rows.length;
                    console.log(this.cardlist, rows)
                    for (let i = 0; i < this.cardlist.length; i++) {
                        console.log(this.cardlist[i].statusStatistics);
                        switch (this.cardlist[i].statusStatistics) {
                            case 0:
                                this.cardlist[i].statuspay = "审核中";
                                this.cardlist[i].statclass = "list-queq";
                                break;
                            case 1:
                                this.cardlist[i].statuspay = "初审通过";
                                this.cardlist[i].statclass = "list-que";
                                break;
                            case 2:
                                this.cardlist[i].statuspay = "终审通过";
                                this.cardlist[i].statclass = "list-quew";
                                break;
                            case 3:
                                this.cardlist[i].statuspay = "已激活";
                                this.cardlist[i].statclass = "list-quee";
                                break;
                            case 4:
                                this.cardlist[i].statuspay = "已首刷";
                                this.cardlist[i].statclass = "list-quee";
                                break;
                            case 5:
                                this.cardlist[i].statuspay = "拒绝";
                                this.cardlist[i].statclass = "list-quer";
                                break;
                            case 6:
                                this.cardlist[i].statuspay = '非首卡';
                                this.cardlist[i].statclass = 'list-que';
                                break;
                            case 7:
                                this.cardlist[i].statuspay = '达标超时';
                                this.cardlist[i].statclass = 'list-que';
                                break;
                        }
                    }
                } else {
                    // uni.hideLoading()
                    // uni.showToast({
                    //     title: res.msg,
                    //     icon: "none",
                    // });
                }
            });
        },
        // 搜索
        searchlist() {
            this.pageNum = 1;
            this.getdata();
        },
        // 清空
        clear() {
            this.search = "";
            this.getdata();
        },
        // 下拉刷新
        onRefresh() {
            this.triggered = "restore";
            this.search = "";
            let len = this.cardlist.length;
            if (len >= this.total) {
                Toast('数据已加载完成');
                return false;
            } else {
                // uni.showToast({
                //     title: "加载中",
                //     icon: "loading",
                //     success: (res) => {
                //         this.pageNum++;
                //         this.getdata();
                //     },
                // });
                this.pageNum++;
                this.getdata();
            }
        },
        openUrl(url) {
            if (!url) return;
            // // #ifdef APP-PLUS
            // plus.runtime.openURL(url);
            // // #endif
            window.location.href = url
        },
    }
}
</script>
<style lang="scss" scoped>
.header-page {
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100vh;

    .header-cont {
        .header-top {
            width: 100%;
            border-bottom: 3px solid #f7f7f7;

            .mech {
                background-color: #ffffff;
                z-index: 99;
            }
        }
    }

    .list-cont {
        flex: 1;
        position: relative;
        background-color: #ffffff;



        .list-tmp {
            width: 95%;
            border-bottom: 2px solid #f6f6f6;
            padding: 10px 0 10px 0;
            margin: auto;

            .list-me {
                justify-content: space-between;
                // align-items: center;

                .list-pm {
                    .list-span {
                        padding-right: 10px;
                        border-right: 2px solid #f6f6f6;
                    }

                    .list-pan {
                        margin-left: 5px;
                    }
                }

                .list-r {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .list-r-schedule {
                        color: rgb(1, 96, 255);
                    }
                }

                .list-yin {
                    line-height: 45px;
                    display: flex;
                    align-items: center;

                    .list-tag {
                        color: #fff;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        padding: 0 4px;
                        border-radius: 3px;
                        margin-right: 2px;
                    }

                    .lisy-lm {
                        font-weight: bold;
                        font-size: 16px;
                    }

                    .lisy-qm {
                        margin-left: 10px;
                        border: 1.5px solid red;
                        padding: 2px;
                        color: red;
                        height: 16px;
                        line-height: 16px;
                        font-size: 8px;
                    }
                }

                .list-que {
                    color: blue;
                    font-weight: bold;
                }

                .list-queq {
                    color: #fac858;
                    font-weight: bold;
                }

                .list-quew {
                    color: #09bb07;
                    font-weight: bold;
                }

                .list-quee {
                    color: orange;
                    font-weight: bold;
                }

                .list-quer {
                    color: red;
                    font-weight: bold;
                }

                .list-quet {
                    color: #8a6de9;
                    font-weight: bold;
                }
            }

            .list-data {
                justify-content: space-between;
                color: #838383;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }

    .pagesli {
        height: 100%;
        width: 100%;
        text-align: center;
        background: #ffffff;
    }
}

.screen {

    .scroll-view_H {
        white-space: nowrap;
        width: 100%;
        margin: auto;
    }

    .scroll-view_content {
        width: 100%;
    }

    width: 100%;
    display: flex;

    .screen_box {
        text-align: center;
        font-size: 14px;
        color: #606266;
        padding: 4px;
    }

    // .screen_box:last-child {
    //   padding-right: 30rpx;
    // }

    .screen_box_active {
        text-align: center;
        position: relative;
        font-size: 14px;
        color: #E02020;
        padding: 4px;
    }

    .screen_box_active::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 15%;
        /* 调整横线左侧的位置，这里设置为div宽度的10% */
        width: 70%;
        /* 横线长度为div宽度的80% */
        height: 1px;
        /* 横线高度为1像素 */
        background-color: #E02020;
        /* 横线颜色为黑色，可以根据需要修改 */
        margin: 0 auto;
        /* 横线居中 */
    }
}

.describe {
    margin: 0 10px;
    padding-bottom: 10px;
    font-size: 12px;
    color: #E02020;
}
</style>